import React, { useEffect, useContext, useState, useReducer } from 'react';
import Util from '../../Util';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import axios from 'axios';
import { apiRoutes } from '../../AppSettings';
import alertify from 'alertifyjs'; 
import { contains } from 'jquery';

const SET_APPOINMENTS = "SET_APPOINMENTS"

const initialValue = {
	appoinments: []
}

const reducer = (state, action) => {
    switch(action.type)
    {
        case SET_APPOINMENTS:
            return {...state, appoinments: action.appoinments}; 
        default:
            return state;
    }
}   

const DashboardTabs = props => {
    const userType = props.userType;
    const patientId = props.PatientId;
   
    const { userState } = useContext(AuthContext);
    
    const doctor = userState.loggedInUser;

    const [patient, setPatient] = useState({});
    const [prescriptions, setPrescriptions] = useState([]);
    const [medicalRecords, setMedicalRecords] = useState([]);
    const [invoices, setInvoices] = useState([]);
   // const [appoinments, setAppoinments] = useState([]);

    const [state, dispature] = useReducer(reducer, props.Details.Appoinments);

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ userState.token
        }
    };

    useEffect(() =>{
        axios.get(apiRoutes.getPatient + patientId, options)
          .then((response) => {
            if(response.status === 200)
            {
                const data = response.data;
                console.log(data.data)
                setPatient(data.data);
            }
          }, (error) => {
            console.log(error);
        });
        loadAppoinments();
    }, [])

    const loadAppoinments = () => {
        axios.get(apiRoutes.getAppoinmentsByPatient + patientId, options)
          .then((response) => {
                if(response.status === 200)
                {
                    const data = response.data;
                    //updateAppoinments(data.values);
                    //updateTopAppoinments(data.values);

                    dispature({type: SET_APPOINMENTS, appoinments: data.data});

                }
            }, (error) => {
                console.log(error.response);
                alertify.error(Util.getErrorMessages(error.response.data.errorMessages));
            });
    }

    const loadPrescriptions = () => {
        console.log("Add prescription")

        axios.get(apiRoutes.GetPrescriptionsByPatientId + patientId, options)
          .then((response) => {
            if(response.status === 200)
            {
                const data = response.data;
                setPrescriptions(data);
            }
          }, (error) => {
            console.log(error);
        });
    }
   
    const loadMedicalRecords = () => {
        console.log("Add MedicalRecords")
        axios.get(apiRoutes.GetMedicalRecordsByPatientId + patientId, options)
          .then((response) => {
            if(response.status === 200)
            {
                const data = response.data;
                console.log(data);
                setMedicalRecords(data);
            }
          }, (error) => {
            console.log(error);
        });
    }

    const loadInvoices = () => {
        console.log("load invoices")
        axios.get(apiRoutes.getInvoicesByPatientId + patientId, options)
          .then((response) => {
            if(response.status === 200)
            {
                const data = response.data;
                console.log(data);
                setInvoices(data);
            }
          }, (error) => {
            console.log(error);
        });
    }

    const download =(item) => {
        Util.downloadBase64File(item.fileNameBase64, item.fileName);
    }

    const handleCancel = (id) => {
        alertify.confirm("Warning!", "Are you sure want to cancel?",
        function () {
            axios.post(apiRoutes.ToggleAppoinment, JSON.stringify({ id: id }), options)
                .then((response) => {
                    alertify.success("Appoinment cancelled successfully");
                   // loadGrid();
                   loadAppoinments();

                  //  setAppoinments(appoinments);

                }, (error) => {
                    console.log(error.response);
                });
        },
        function () {

        });
    }

    return (  
        <div className="card">
            <div className="card-body pt-0">
                <nav className="user-tabs mb-4">
                    <ul className="nav nav-tabs nav-tabs-bottom nav-justified">
                        <li className="nav-item">
                            <a className="nav-link active" href="#pat_appointments" data-toggle="tab">Appointments</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#pat_prescriptions" data-toggle="tab" onClick={loadPrescriptions}>Prescriptions</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#pat_medical_records" data-toggle="tab" onClick={loadMedicalRecords}><span className="med-records">Medical Records</span></a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="#pat_billing" data-toggle="tab" onClick={loadInvoices}>Billing</a>
                        </li>
                    </ul>
                </nav>
                <div className="tab-content pt-0">
                    <div id="pat_appointments" className="tab-pane fade show active">
                        <div className="card card-table mb-0">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-hover table-center mb-0">
                                        <thead>
                                            <tr>
                                                <th>Appt#</th>
                                                <th>Doctor</th>
                                                <th>Appt Date</th>
                                                <th>Booking Date</th>
                                                <th>Amount</th>
                                                <th>Follow Up</th>
                                                <th>Status</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                state.appoinments != undefined && state.appoinments.map(a => (
                                                    <tr key={a.appoinmentId}>
                                                         <td>{a.appoinmentNumber}</td>
                                                        <td>
                                                            <h2 className="table-avatar">
                                                                {
                                                                     userType == "Doctor" ? <a className="avatar avatar-sm mr-2"  href="#">  <img className="avatar-img rounded-circle" src={Util.loadImage(a.doctor.profileImage)} alt="User Image" /> </a>
                                                                     :  <Link className="avatar avatar-sm mr-2" to={
                                                                        {
                                                                            pathname: `/doctorprofile`,
                                                                            state: {
                                                                                selectedDoctor: JSON.stringify(a.doctor)
                                                                            }
                                                                        }
                                                                    }><img className="avatar-img rounded-circle" src={Util.loadImage(a.doctor.profileImage)} alt="User Image" />
                                                                    </Link> 
                                                                }
                                                                {
                                                                     userType == "Doctor" ? <div>Dr. {a.doctor.firstName} {a.doctor.lastName} <span>{a.doctor.category}</span></div>
                                                                     : <Link to={
                                                                        {
                                                                            pathname: `/doctorprofile`,
                                                                            state: {
                                                                                selectedDoctor: JSON.stringify(a.doctor)
                                                                            }
                                                                        }
                                                                    }>Dr. {a.doctor.firstName} {a.doctor.lastName} <span>{a.doctor.category}</span>
                                                                    </Link>
                                                                }
                                                            </h2>
                                                        </td>
                                                        <td>{Util.getFormatDate({date: a.appoinmentDate})} <span className="d-block text-info">{a.appoinmentTime} </span></td>
                                                        <td>{Util.getFormatDate({date: a.createdDate})}</td>
                                                        <td>{a.totalAmount}</td>
                                                        <td>{Util.getFormatDate({date: a.followUpDate}) }</td>
                                                        <td>
                                                            {
                                                                (a.isActive != undefined && a.isActive) ? <span className="badge badge-pill bg-success-light">Confirmed</span>
                                                                : <span className="badge badge-pill bg-danger-light">Cancelled</span>
                                                            }
                                                        </td>
                                                        <td className="text-right">
                                                            <div className="table-action">
                                                            {
                                                                userType == "Patient" && 
                                                                (a.isActive) &&
                                                                <div>
                                                                    <a href="javascript:void(0);" className="btn btn-sm bg-primary-light" onClick={e => handleCancel(a.appoinmentId)}>
                                                                        <i className="fas fa-print"></i> Cancel
                                                                    </a>
                                                                </div>
                                                            } 
                                                            {
                                                                userType == "Doctor" && 
                                                                <div>
                                                                    <Link className="btn btn-sm bg-purple-light" title="Add Prescription" to={
                                                                        {
                                                                            pathname: `/addprescription`,
                                                                            state: {
                                                                                doctor: JSON.stringify(doctor),
                                                                                patient: JSON.stringify(patient),
                                                                                appoinments: JSON.stringify([a]),
                                                                                prescriptionId: 0
                                                                            }
                                                                        }
                                                                    }><i className="fas fa-list-ul"></i></Link>
                                                                    <Link className="btn btn-sm bg-warning-light" title="Add Medical Record" to={
                                                                        {
                                                                            pathname: `/addmedicalrecord`,
                                                                            state: {
                                                                                doctor: JSON.stringify(doctor),
                                                                                patient: JSON.stringify(patient),
                                                                                appoinments: JSON.stringify([a])
                                                                            }
                                                                        }
                                                                    }><i className="fas fa-edit"></i></Link>

                                                                    <Link className="btn btn-sm bg-info-light" title="Add Billing" to={
                                                                        {
                                                                            pathname: `/addbilling`,
                                                                            state: {
                                                                                doctor: JSON.stringify(doctor),
                                                                                patient: JSON.stringify(patient),
                                                                                appoinments: JSON.stringify([a]),
                                                                                invoiceId: 0
                                                                            }
                                                                        }
                                                                    }> <i className="far fa-sticky-note"></i></Link>
                                                                </div>
                                                            } 
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="pat_prescriptions">
                        {
                            userType == "Doctor" && 
                            <div className="text-right">
                                <Link to={
                                    {
                                        pathname: `/addprescription`,
                                        state: {
                                            doctor: JSON.stringify(doctor),
                                            patient: JSON.stringify(patient),
                                            appoinments: JSON.stringify(state.appoinments),
                                            prescriptionId: 0
                                        }
                                    }
                                } 
                                className="add-new-btn">Add Prescription</Link>
                            </div>
                        }
                        <div className="card card-table mb-0">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-hover table-center mb-0">
                                        <thead>
                                            <tr>
                                                <th>Date </th>
                                                <th>Name</th>
                                                <th>Created by </th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                prescriptions.map(item => (
                                                    <tr key={item.prescription.prescriptionId}>
                                                        <td>{Util.getFormatDate({date: item.prescription.createdDate})}</td>
                                                        <td>{item.prescription.name}</td>
                                                        <td>
                                                            <h2 className="table-avatar">
                                                                {
                                                                     userType == "Doctor" ? <a className="avatar avatar-sm mr-2"  href="#"> <img className="avatar-img rounded-circle" src={Util.loadImage(item.doctor.profileImage)} alt="User Image" /></a>
                                                                     :  <Link className="avatar avatar-sm mr-2" to={
                                                                        {
                                                                            pathname: `/doctorprofile`,
                                                                            state: {
                                                                                selectedDoctor: JSON.stringify(item.doctor)
                                                                            }
                                                                        }
                                                                    }><img className="avatar-img rounded-circle" src={Util.loadImage(item.doctor.profileImage)} alt="User Image" />
                                                                    </Link>    
                                                                }
                                                                {
                                                                     userType == "Doctor" ? <div>Dr. {item.doctor.firstName} {item.doctor.lastName} <span>{item.doctor.category}</span></div>
                                                                     :  <Link to={
                                                                            {
                                                                                pathname: `/doctorprofile`,
                                                                                state: {
                                                                                    selectedDoctor: JSON.stringify(item.doctor)
                                                                                }
                                                                            }
                                                                        }>Dr. {item.doctor.firstName} {item.doctor.lastName} <span>{item.doctor.category}</span>
                                                                    </Link>
                                                                }
                                                             </h2>
                                                        </td>
                                                        <td className="text-right">
                                                            <div className="table-action">
                                                                <Link className="btn btn-sm bg-info-light" to={
                                                                    {
                                                                        pathname: `/viewprescription`,
                                                                        state: {
                                                                            prescriptionId: JSON.stringify(item.prescription.prescriptionId),
                                                                            doctor: JSON.stringify(doctor),
                                                                            patient: JSON.stringify(patient)
                                                                        }
                                                                    }
                                                                }><i className="far fa-eye"></i> View
                                                                </Link>
                                                                {
                                                                    userType == "Doctor" && 
                                                                    <Link className="btn btn-sm bg-success-light" to={
                                                                        {
                                                                            pathname: `/addprescription`,
                                                                            state: {
                                                                                doctor: JSON.stringify(doctor),
                                                                                patient: JSON.stringify(patient),
                                                                                appoinments: JSON.stringify(state.appoinments),
                                                                                prescriptionId: JSON.stringify(item.prescription.prescriptionId)
                                                                            }                    
                                                                        }
                                                                    }><i className="fas fa-edit"></i> Edit</Link>
                                                                }
                                                                
                                                               
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="pat_medical_records" className="tab-pane fade">
                        {
                            userType == "Doctor" && 
                            <div className="text-right">		
                                <Link className="add-new-btn" to={
                                    {
                                        pathname: `/addmedicalrecord`,
                                        state: {
                                            doctor: JSON.stringify(doctor),
                                            patient: JSON.stringify(patient),
                                            appoinments: JSON.stringify(state.appoinments)
                                        }
                                    }
                                }>Add Medical Records</Link>
                            </div>
                        }
                        <div className="card card-table mb-0">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-hover table-center mb-0">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Date </th>
                                                <th>Description</th>
                                                <th>Attachment</th>
                                                <th>Created</th>
                                              
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                medicalRecords.map(item => (
                                                    <tr key={item.medicalRecord.medicalRecordId}>
                                                        <td>{item.medicalRecord.medicalRecordNumber}</td>
                                                        <td>{Util.getFormatDate({date: item.medicalRecord.createdDate})}</td>
                                                        <td>{item.medicalRecord.description}</td>
                                                        <td><a className="download" onClick={() => {download(item.medicalRecord)}}>{item.medicalRecord.fileName}</a></td>
                                                        <td>
                                                            <h2 className="table-avatar">
                                                                {
                                                                     userType == "Doctor" ? <a className="avatar avatar-sm mr-2"  href="#"> <img className="avatar-img rounded-circle" src={Util.loadImage(item.doctor.profileImage)} alt="User Image" /></a>
                                                                     :  <Link className="avatar avatar-sm mr-2" to={
                                                                        {
                                                                            pathname: `/doctorprofile`,
                                                                            state: {
                                                                                selectedDoctor: JSON.stringify(item.doctor)
                                                                            }
                                                                        }
                                                                    }><img className="avatar-img rounded-circle" src={Util.loadImage(item.doctor.profileImage)} alt="User Image" />
                                                                    </Link>    
                                                                }
                                                                {
                                                                     userType == "Doctor" ? <div>Dr. {item.doctor.firstName} {item.doctor.lastName} <span>{item.doctor.category}</span></div>
                                                                     :  <Link to={
                                                                            {
                                                                                pathname: `/doctorprofile`,
                                                                                state: {
                                                                                    selectedDoctor: JSON.stringify(item.doctor)
                                                                                }
                                                                            }
                                                                        }>Dr. {item.doctor.firstName} {item.doctor.lastName} <span>{item.doctor.category}</span>
                                                                    </Link>
                                                                }
                                                            </h2>
                                                        </td>
                                                        
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="pat_billing" className="tab-pane fade">
                        {
                            userType == "Doctor" && 
                            <div className="text-right">
                                <Link className="add-new-btn" to={
                                    {
                                        pathname: `/addbilling`,
                                        state: {
                                            doctor: JSON.stringify(doctor),
                                            patient: JSON.stringify(patient),
                                            appoinments: JSON.stringify(state.appoinments),
                                            invoiceId: 0
                                        }
                                    }
                                }>Add Billing</Link>
                            </div>
                        }
                        <div className="card card-table mb-0">
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-hover table-center mb-0">
                                        <thead>
                                            <tr>
                                                <th>Invoice No</th>
                                                <th>Doctor</th>
                                                <th>Amount</th>
                                                <th>Paid On</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                invoices.map(item => (
                                                    <tr key={item.invoice.invoiceId}>
                                                        <td>
                                                            <Link to={
                                                                    {
                                                                        pathname:'/invoiceview',
                                                                        state: {
                                                                            invoiceId: item.invoice.invoiceId
                                                                        }
                                                                    }
                                                            }>{item.invoice.invoiceNumber}</Link>
                                                        </td>
                                                        <td>
                                                            <h2 className="table-avatar">
                                                                {
                                                                     userType == "Doctor" ? <a className="avatar avatar-sm mr-2"  href="#"> <img className="avatar-img rounded-circle" src={Util.loadImage(item.doctor.profileImage)} alt="User Image" /></a>
                                                                     :  <Link className="avatar avatar-sm mr-2" to={
                                                                        {
                                                                            pathname: `/doctorprofile`,
                                                                            state: {
                                                                                selectedDoctor: JSON.stringify(item.doctor)
                                                                            }
                                                                        }
                                                                    }><img className="avatar-img rounded-circle" src={Util.loadImage(item.doctor.profileImage)} alt="User Image" />
                                                                    </Link>    
                                                                }
                                                                {
                                                                     userType == "Doctor" ? <div>Dr. {item.doctor.firstName} {item.doctor.lastName} <span>{item.doctor.category}</span></div>
                                                                     :  <Link to={
                                                                            {
                                                                                pathname: `/doctorprofile`,
                                                                                state: {
                                                                                    selectedDoctor: JSON.stringify(item.doctor)
                                                                                }
                                                                            }
                                                                        }>Dr. {item.doctor.firstName} {item.doctor.lastName} <span>{item.doctor.category}</span>
                                                                    </Link>
                                                                }
                                                            </h2>
                                                        </td>
                                                        <td>${item.invoice.totalAmount}</td>
                                                        <td>{Util.getFormatDate({date: item.invoice.createdDate})}</td>
                                                        <td className="text-right">
                                                            <div className="table-action">
                                                                    <Link className="btn btn-sm bg-info-light" to={
                                                                        {
                                                                            pathname:'/invoiceview',
                                                                            state: {
                                                                                invoiceId: item.invoice.invoiceId
                                                                            }
                                                                        }
                                                                    }>  <i className="far fa-eye"></i> View
                                                                    </Link>    
                                                                    {
                                                                        userType == "Doctor" && 
                                                                        <Link className="btn btn-sm bg-success-light" to={
                                                                            {
                                                                                pathname: `/addbilling`,
                                                                                state: {
                                                                                    doctor: JSON.stringify(doctor),
                                                                                    patient: JSON.stringify(patient),
                                                                                    appoinments: JSON.stringify(state.appoinments),
                                                                                    invoiceId: JSON.stringify(item.invoice.invoiceId)
                                                                                }                    
                                                                            }
                                                                        }><i className="fas fa-edit"></i> Edit</Link>
                                                                    }
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
               
    );
}
 
export default DashboardTabs;